export const enableRooms = (layout, rooms) => {
    rooms.forEach((room) => {
        const data = room.dataset;
        const path = layout.querySelector(`#Parking [id="PRK-${data.number}"]`) || layout.querySelector(`#Storage [id="STR-${data.number}"]`);
        
        if ( path )
        {
            path.classList.add(`enabled`);
        }
    });
};
